import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'molecule-previous-year-comparison',
  templateUrl: './previous-year-comparison.component.html',
  styleUrls: ['./previous-year-comparison.component.scss'],
})
export class PreviousYearComparisonComponent implements OnInit, OnChanges {
  @Input() comparisonValue: string = "";
  @Input() isIncrease: boolean = false;
  @Input() fontSize: string = '';
  @Input() tooltipText = 'Respecto al año anterior';

  public showIcon: boolean = true;
  constructor(private translateService: TranslateService) {}


  ngOnInit(): void {
    this.showIcon = parseFloat(this.comparisonValue) !== 0;
  }

  ngOnChanges(changes: SimpleChanges){
    if (changes['comparisonValue']) {
      this.showIcon = parseFloat(this.comparisonValue) !== 0;
    }
  }

  getTooltipTranslation(): string {
    if (!this.tooltipText) return '';

    // Separar el texto antes de los dos puntos y los números
    const [textPart, numberPart] = this.tooltipText.split(':');

    if (!textPart) return this.tooltipText;

    // Traducir solo la parte del texto
    const translatedText = this.translateService.instant('TOOLTIPS.' + textPart.trim());

    // Reconstruir el string con la traducción y los números originales
    return numberPart ? `${translatedText}: ${numberPart}` : translatedText;
  }
}
